import React from 'react'

import i18n from 'i18n-literally'
import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import createLogger from '~/src/Lib/Logging'
import PageTitle from '~/src/UI/Shared/PageTitle'

const logger = createLogger('Routes/NotFound')

export const NotFoundRoute = ({ title = i18n`Page Not Found` }) => {
  const { routeInfo } = useConnect('selectRouteInfo')
  logger.warn("Couldn't find the requested page.")
  logger.debug(routeInfo)
  return <PageTitle disablePortal title={title} color="textPrimary" className="center-all" />
}

NotFoundRoute.propTypes = {
  title: PropTypes.string,
}
NotFoundRoute.displayName = 'NotFound'

export default NotFoundRoute
